import deviceFingerprint from "src/shared/utilities/deviceFingerprint";

import { ASK_QUESTION, SCHEDULE_SHOWING } from "../../constants/formTypes";
import analytics from "../analytics";

const handleContactExpert = ({
  contactExpert,
  contactFormType,
  expertsApiUuid,
  listing,
  modelVersion,
  segmentName
}) => async (formData, formikBag) => {
  try {
    const {
      body,
      building_id,
      buy_sell,
      email,
      expert,
      listing_id,
      name,
      phone,
      subject
    } = formData;
    const message_owner = listing_id
      ? { message_owner_class: "sale", message_owner_id: listing_id }
      : { message_owner_class: "building", message_owner_id: building_id };
    const role = buy_sell ? { role: `${buy_sell}er` } : {};
    let origin_label = {};
    if (contactFormType) {
      // eslint-disable-next-line default-case
      switch (contactFormType) {
        case ASK_QUESTION: {
          origin_label = { origin_label: "experts_hdp_ask_question" };
          break;
        }
        case SCHEDULE_SHOWING: {
          origin_label = { origin_label: "experts_hdp_request_tour" };
          break;
        }
      }
    }

    const { data: { contact_expert = {} } = {} } = await contactExpert({
      variables: {
        input: {
          contact_id: expert.contact.id,
          device_fingerprint: deviceFingerprint(),
          message_details: {
            email_content: body,
            email_subject: subject,
            experts_api_uuid: expertsApiUuid,
            sender_email: email,
            sender_name: name,
            sender_phone: phone,
            ...origin_label
          },
          segment: segmentName,
          ...message_owner,
          ...role
        }
      }
    });

    if (contact_expert.errors) {
      throw contact_expert.errors;
    }

    const {
      contact: { id, is_pro }
    } = expert;

    let gaLabel = `expert_contact_id=${id}|pro=${is_pro}|uuid=${expertsApiUuid}`;

    if (buy_sell || contactFormType) {
      gaLabel += `|type=${buy_sell || contactFormType}`;
    }

    analytics({
      action: "contact_building_expert",
      experts_model_version: modelVersion,
      isHdp: Boolean(listing),
      label: gaLabel
    });

    return {};
  } catch (error) {
    if (formikBag) {
      formikBag.setFieldError("form_submission", "Failed to deliver message");
    }

    return { error };
  }
};

export default handleContactExpert;
